import React from "react";
import { dialog, Button } from "nq-component";
import Table from "../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import { InfiniteScroll } from "nq-component";
import withRouter from "../../../withRouter";
import Search from "../../../components/Search";
import BaseListPage from "../../../base/BaseListPage";
import CardView from "../../../components/common/CardView";
import DisbursementsPresenter from "./DisbursementsPresenter";
import PayrollListForm from "../PayrollList/PayrollListForm";
import { caseRegistry } from "../PayrollList/payrollForm/payrollCases/PayrollCasesPage";
import Progress from "../../../components/Progress";

class DisbursementsPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.state = {
      objects: [],
      limit: 10,
      current: 1,
      count: 0,
      objectData: [],
      isModalOpen: false,
      isBackpay: false,
    };
    this.presenter = new DisbursementsPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
  }

  getCollectionName() {
    return "disbursement";
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  withItem =
    (data = {}) =>
    (caseName) => {
      const caseHandler = caseRegistry[caseName];
      return typeof caseHandler === "function" ? caseHandler(data) : false;
    };

  _isBackPay(data) {
    const checkCase = this.withItem(data);

    return (
      checkCase("isBasicJoAddendum") ||
      checkCase("isBasicBackpay") ||
      checkCase("isApBackpay") ||
      checkCase("isIndividualAPBackpay") ||
      checkCase("isIndividualJoBackpay")
    );
  }

  async handlePrint(data) {
    const item = data?.disbursementData[0];
    const isBackpay = this._isBackPay(item);

    this.setState({ objectData: item, isModalOpen: true, isBackpay });
  }

  closeModal() {
    this.setState({ isModalOpen: false });
  }

  async handleDelete(data) {
    this.presenter.getHandleDelete(data);
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, limit, current } = this.state;

    const includeLabel = Object.keys(schema.fields).filter(
      (fields) =>
        fields !== "payrollCode" &&
        fields !== "employee" &&
        fields !== "createdAt"
    );
    if (!schema) return <Progress />;

    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} Finance {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    {schema.label}
                  </span>
                </p>
              </div>
              <CardView style={{ borderRadius: 0 }}>
                <Search
                  schemas={this.getSchemas()}
                  onSubmit={this.searchSubmit.bind(this)}
                  fields={schema.fields}
                />
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center">
                    <h4 className="text-primary">{schema.label}</h4>
                  </div>
                </CardView>
              </div>

              <Table
                printDisbursement={this.handlePrint.bind(this)}
                removeDisbursement={this.handleDelete.bind(this)}
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-three-dots-vertical" />,
                    actionType: "Print Disbursement",
                  },
                ]}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["Id", "Created At", "Updated At", ...includeLabel]
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
        {this.state.isModalOpen && (
          <PayrollListForm
            closeModal={this.closeModal.bind(this)}
            refetchData={this.refetchData.bind(this)}
            isBackpay={this.state.isBackpay}
            objectData={this.state.objectData}
          />
        )}
      </>
    );
  }
}

export default withRouter(DisbursementsPage);
